import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Sales from "@/pages/Sales";
import QuoteBuilder from "@/pages/QuoteBuilder";
import Customers from "@/pages/Customers";
import Items from "@/pages/Items";
import Admin from "@/pages/Admin";
import Reports from "@/pages/Reports";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid h-screen place-items-center text-sm text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/sales" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/sales" replace />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/sales/new" element={<QuoteBuilder />} />
            <Route path="/sales/:id" element={<QuoteBuilder />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/items" element={<Items />} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="/reports" element={<Protected admin><Reports /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/sales" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
